import { SMap, voidFunction } from '@avantia/client-and-server-utilities';

export type HpAddToActionHistoryFunction = (key: string, data: SMap<any>) => void;

let func: HpAddToActionHistoryFunction = voidFunction;

export function registerAddToActionHistoryFunction(addToHistory: HpAddToActionHistoryFunction): void {
  func = addToHistory || voidFunction;
}

export function addToActionHistory(key: string, data: SMap<any>): void {
  func(key, data);
}
